




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Option, Select, Tag } from 'element-ui';

import { fileTagOptions } from '@/constants/fileTagOptions.ts';

@Component({
  components: {
    'el-option': Option,
    'el-select': Select,
    'el-tag': Tag
  }
})
export default class FileTag extends Vue {
  @Prop({ required: true }) value!: string;
  @Prop({ required: true }) isEditing!: boolean;

  fileTagOptions = fileTagOptions();

  get tagValue() {
    switch (this.value) {
      case 'an':
      case 'bl':
      case 'customs_permit':
      case 'insurance':
      case 'co':
      case 'invoice':
      case 'packing_list':
        return this.$t(`tagOptions.${this.value}`);
      default:
        return this.value;
    }
  }

  get tagColor() {
    switch (this.value) {
      case 'an':
        return 'bg-red-200 text-black border-red-300';
      case 'bl':
        return 'bg-blue-200 text-black border-blue-300';
      case 'customs_permit':
        return 'bg-orange-200 text-black border-orange-300';
      case 'insurance':
        return 'bg-green-200 text-black border-green-300';
      case 'co':
        return 'bg-yellow-300 text-black border-yellow-400';
      case 'invoice':
        return 'bg-red-400 text-black border-red-500';
      case 'packing_list':
        return 'bg-blue-400 text-black border-blue-500';
      default:
        return 'bg-gray-400 text-black border-gray-500';
    }
  }

  get tagInput() {
    return this.value;
  }

  set tagInput(data) {
    this.$emit('input', data);
  }
}
